// @ts-check
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import { LoadingComponent } from '../components/loading-component';

import { getClients } from '../../../clients/presentation/redux/actions/client-actions';
import { FloatingActionButtonSize } from '../components/add-component';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';
import { Grid, Paper } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0),
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  sectionHeading: {
    margin: theme.spacing(2)
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    cursor: 'pointer'
  },
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  clientLogo: {
    height: '8rem',
    width: '8rem',
    objectFit: 'contain'
  }
}));

function Client({ client }) {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Paper
      className={classes.paper}
      elevation={0}
      onClick={() => history.push(`/admin/${client.id}`)}
    >
      <img className={classes.clientLogo} src={client.logo} alt="logo" />

      <div>
        <b>{client.name}</b>
      </div>
    </Paper>
  );
}

export function Clients({ clients }) {
  const renderClients = clients.map((value, key) => {
    return (
      <Grid key={key} item xs={6} md={4}>
        <Client client={value} />
      </Grid>
    );
  });

  return (
    <Grid container spacing={2}>
      {renderClients}
    </Grid>
  );
}

export default function AdminPage() {
  const classes = useStyles();

  const { clients, loading } = useSelector((state) => state.clients);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getClients());
  }, [dispatch]);

  return (
    <>
      <React.Fragment>
        <CssBaseline />
        <Container className={classes.container}>
          {loading && <LoadingComponent />}
          {!loading && (
            <>
              <BackNavigationComponent page="Admin" uri="/" />
              <FloatingActionButtonSize />
              <Clients clients={clients} />
            </>
          )}
        </Container>
      </React.Fragment>
    </>
  );
}
